import { AFTER_SALES, CAMPAIGN } from 'constants/ExtensionConstants';
import { DEFAULT_STATUS } from 'constants/InterventionConstants';
import { PARTS, SALES, TECHNICIAN } from 'constants/ModeConstants';

import { fetchFilteredCampaignFiles } from 'modules/campaignFiles/actions/core';
import { genericFetchInterventions } from 'modules/interventions/actions/core';
import { createDictionary, uniq } from 'utils/ObjectUtils';

export const DEFAULT_LINKED_INTERVENTION_PARAMS = {
  size: 10,
  mode: TECHNICIAN,
  projection: 'page',
  sort: 'startDate,desc',
  status: DEFAULT_STATUS,
  fields:
    'id,referenceId,appointmentId,brand,status,createdBy,createdOn,module,vehicleInfo,vehicleInfo.model,startDate',
};

export const OPTIONS = {
  [TECHNICIAN]: AFTER_SALES,
  [PARTS]: PARTS,
  [SALES]: SALES,
  [CAMPAIGN]: CAMPAIGN,
};

export const ACTION_BY_EXTENSION = createDictionary(
  {
    [CAMPAIGN]: ({ customerId, page }) =>
      fetchFilteredCampaignFiles({ customerId, page }, { source: 'customer-interventions' }),
  },
  params =>
    genericFetchInterventions(
      { ...DEFAULT_LINKED_INTERVENTION_PARAMS, ...params },
      { source: 'customer-interventions' }
    )
);

export const linkedEntitiesFormatter = (entities = []) =>
  entities.reduce(
    (acc, entity) => {
      const { startDate, createdOn } = entity;
      const date = new Date(startDate ?? createdOn);
      const year = date.getFullYear().toString();

      return {
        ...acc,
        [year]: [...(acc[year] ?? []), entity],
        years: uniq([...acc.years, year]),
      };
    },
    { years: [] }
  );
